import { Tilelet } from "@vds/tiles";
import { getIcon } from "../../../global/utility/statisticsUtil";
import { useStatisticContext } from "../contexts/StatisticContext";
import { STATISTICS_TEST_IDS } from "../statisticsConstants";
import { Icon } from "@vds/icons";

const LandingFilterBar = () => {
  const {  cvAppNames, cvappNameList, landingCVAppNameList,  setFilterType } = useStatisticContext();

  return (
    <div>
      <p>Select an app to view statistics</p>
      <div className="landingFilterBar" style={{ paddingBottom: "10px", flexDirection: "column" }}>
        <div
          style={{
            display: "flex",
            color: "#6f7171",
            padding: "10px 20px 0 20px",
            margin: 0
          }}
        >
          <p> Statistics </p>{" "}
        </div>
        <div className="filterTowerHideFilter" style={{ margin: "0px", padding: "10px" }}>
          <div className="tags-input-container" style={{ width: "100%", gap: "1.3em" }}>
            {landingCVAppNameList.map((widget, i) => {
              if (
                cvAppNames.find((f) => {
                  return f.resources.displayName === widget;
                }).category === "Statistics Apps"
              ) {
                return (
                  <div
                    key={widget + i}
                    className="tag-itemDiv"
                    style={{
                      opacity: cvappNameList.indexOf(widget) > -1 ? "1" : "0.4",
                      pointerEvents: cvappNameList.indexOf(widget) > -1 ? "auto" : "none"
                    }}
                  >
                    <div className="titleletClass"
                    data-testid={STATISTICS_TEST_IDS.STATISTICS_TILELET}
                    aria-label={widget}
                    onClick={(e) => {
                        setFilterType(e);
                       //getAllBaselineCountData();
                      }}>
                      <span>{widget}</span>
                      <div className="titleletClassIcon"><Icon  name={ getIcon(widget)}
                      size= "medium"></Icon></div>
                      
                      </div>
                   
                  </div>
                );
              }
            })}
          </div>
        </div>
      </div>
      <div className="landingFilterBar" style={{ flexDirection: "column" }}>
        <div
          style={{
            color: "#6f7171",
            display: "flex",
            padding: "10px 20px 0 20px",
            margin: 0
          }}
        >
          <p> Events </p>{" "}
        </div>
        <div className="filterTowerHideFilter" style={{ margin: "0px", padding: "10px" }}>
          <div className="tags-input-container" style={{ width: "100%", gap: "1.3em" }}>
            {landingCVAppNameList.map((widget, i) => {
              if (
                cvAppNames.find((f) => {
                  return f.resources.displayName === widget;
                }).category !== "Statistics Apps"
              ) {
                return (
                  <div
                    key={widget + i}
                    className="tag-itemDiv"
                    style={{
                      opacity: cvappNameList.indexOf(widget) > -1 ? "1" : "0.4",
                      pointerEvents: cvappNameList.indexOf(widget) > -1 ? "auto" : "none"
                    }}
                  >
                    <div className="titleletClass"
                    data-testid={STATISTICS_TEST_IDS.STATISTICS_TILELET}
                    aria-label={widget}
                    onClick={(e) => {
                        setFilterType(e);
                        //getAllBaselineCountData();
                      }}>
                      <span>{widget}</span>
                      <div className="titleletClassIcon"><Icon  name={ getIcon(widget)}
                      size= "medium"></Icon></div>
                      
                      </div>
                    
                  </div>
                );
              }
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingFilterBar;
